import { render, staticRenderFns } from "./AddDenominationSetup.vue?vue&type=template&id=38d142e2&"
import script from "./AddDenominationSetup.vue?vue&type=script&lang=js&"
export * from "./AddDenominationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports